"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.0417 32.1458C24.3199 32.349 24.6555 32.4585 25 32.4585C25.3446 32.4585 25.6802 32.349 25.9584 32.1458L35.2084 25C35.4172 24.8982 35.6008 24.7511 35.7456 24.5694C35.8904 24.3877 35.9929 24.176 36.0456 23.9497C36.0982 23.7234 36.0998 23.4882 36.0501 23.2612C36.0004 23.0343 35.9007 22.8212 35.7582 22.6377C35.6158 22.4541 35.4342 22.3046 35.2267 22.2001C35.0192 22.0955 34.791 22.0386 34.5587 22.0334C34.3265 22.0282 34.0959 22.0748 33.884 22.17C33.672 22.2651 33.4839 22.4063 33.3334 22.5833L26.5834 27.75V8.52083C26.5834 8.10643 26.4188 7.709 26.1257 7.41597C25.8327 7.12295 25.4353 6.95833 25.0209 6.95833C24.6065 6.95833 24.209 7.12295 23.916 7.41597C23.623 7.709 23.4584 8.10643 23.4584 8.52083V27.75L16.6667 22.5833C16.5162 22.4063 16.3281 22.2651 16.1161 22.17C15.9042 22.0748 15.6736 22.0282 15.4413 22.0334C15.209 22.0386 14.9808 22.0955 14.7733 22.2001C14.5658 22.3046 14.3843 22.4541 14.2418 22.6377C14.0994 22.8212 13.9997 23.0343 13.95 23.2612C13.9003 23.4882 13.9019 23.7234 13.9545 23.9497C14.0072 24.176 14.1097 24.3877 14.2545 24.5694C14.3993 24.7511 14.5829 24.8982 14.7917 25L24.0417 32.1458Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.4792 27.9375C44.0648 27.9375 43.6674 28.1021 43.3744 28.3951C43.0813 28.6882 42.9167 29.0856 42.9167 29.5V37.3125C42.9167 38.0032 42.6423 38.6655 42.154 39.1539C41.6656 39.6423 41.0032 39.9167 40.3125 39.9167H9.68754C8.99687 39.9167 8.33449 39.6423 7.84612 39.1539C7.35774 38.6655 7.08337 38.0032 7.08337 37.3125V29.5C7.08337 29.0856 6.91875 28.6882 6.62573 28.3951C6.3327 28.1021 5.93528 27.9375 5.52087 27.9375C5.10647 27.9375 4.70905 28.1021 4.41602 28.3951C4.12299 28.6882 3.95837 29.0856 3.95837 29.5V37.3125C3.95837 38.832 4.56198 40.2892 5.63641 41.3636C6.16841 41.8956 6.79999 42.3176 7.49508 42.6056C8.19018 42.8935 8.93518 43.0417 9.68754 43.0417H40.3125C41.832 43.0417 43.2893 42.4381 44.3637 41.3636C45.4381 40.2892 46.0417 38.832 46.0417 37.3125V29.5C46.0417 29.0856 45.8771 28.6882 45.5841 28.3951C45.291 28.1021 44.8936 27.9375 44.4792 27.9375Z",
    fill: fill
  }));
};

exports["default"] = _default;